import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = ['modal', 'search', 'list', 'item', 'empty'];

  open(event) {
    if (event) event.preventDefault();
    this.modalTarget.classList.remove('hidden');
    if (this.hasSearchTarget) {
      this.searchTarget.value = '';
      this._showAll();
      setTimeout(() => this.searchTarget.focus(), 0);
    }
  }

  close(event) {
    if (event) event.preventDefault();
    this.modalTarget.classList.add('hidden');
  }

  filter() {
    const q = (this.searchTarget.value || '').trim().toLowerCase();
    let visible = 0;
    this.itemTargets.forEach((el) => {
      const name = el.dataset.name || '';
      const match = !q || name.indexOf(q) !== -1;
      el.classList.toggle('hidden', !match);
      if (match) visible++;
    });
    if (this.hasEmptyTarget) {
      this.emptyTarget.classList.toggle('hidden', visible !== 0);
    }
  }

  _showAll() {
    this.itemTargets.forEach((el) => el.classList.remove('hidden'));
    if (this.hasEmptyTarget) this.emptyTarget.classList.add('hidden');
  }
}
